import { Card } from '@/shared/ui/card';

interface ActivityTimelineSkeletonProps {
  /** Number of placeholder rows — size to the page so the layout doesn't jump. */
  rows: number;
}

/**
 * Pulsing placeholder timeline shown while a new activity page is fetching.
 * Mirrors the real timeline's node + card layout (and its left connector line)
 * so row height and pagination position stay fixed during the page swap.
 */
export function ActivityTimelineSkeleton({ rows }: ActivityTimelineSkeletonProps) {
  return (
    <div className="relative" data-testid="log-timeline-skeleton">
      <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-border" />
      <div className="space-y-6">
        {[...Array(rows)].map((_, i) => (
          <div key={`log-skeleton-${i}`} className="relative flex gap-6">
            <div className="relative z-10 flex-shrink-0">
              <div className="w-12 h-12 rounded-full border-4 border-background bg-muted animate-pulse" />
            </div>
            <div className="flex-1 pb-6">
              <Card className="border-border">
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="h-5 w-20 rounded-full bg-muted animate-pulse" />
                    <div className="h-3 w-32 rounded bg-muted animate-pulse" />
                  </div>
                  <div className="h-3.5 w-48 rounded bg-muted animate-pulse" />
                  <div className="mt-3 h-3 w-28 rounded bg-muted animate-pulse" />
                </div>
              </Card>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
